import { ParkerInfoDTO, ParkerTagDTO } from './../../../../base/models/models.swagger.generated';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-parker-registration-detail-parker-details',
    templateUrl: './parker-registration-detail-parker-details.component.html',
    styleUrls: ['./parker-registration-detail-parker-details.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class ParkerRegistrationDetailParkerDetailsComponent {
  @Input()
  public parker: ParkerInfoDTO;

  @Input()
  public companyName: string;

  @Input()
  public unknowParkerTagFull: string;

  @Input()
  public knownTag: ParkerTagDTO;

  public get licenseNumber(): string {
    if (this.knownTag) {
      return (this.knownTag.countryCode ? this.knownTag.countryCode + ' ' : '') + (this.knownTag.controlPlateNumber ?? '');
    }
    return this.unknowParkerTagFull;
  }
}
